interface ReverseGeoCode {
    address: string;
    city: string;
    postalCode: string;
    locality: string;
    state: string;
    country: string;
    error?: boolean;
    mainText: string;
    secondaryText: string;
  }
  
  export const reverseGeoCode = async (
    lat: number,
    lng: number
  ): Promise<ReverseGeoCode> => {
    const basePath =
      process.env.NEXT_PUBLIC_ENV === "LOCAL"
        ? ""
        : process.env.NEXT_PUBLIC_GOOGLE_MAPS_URL;
    const URL = `/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.NEXT_PUBLIC_GMAPS_API_KEY}`;
    const response = await fetch(basePath + URL, {
      headers: {},
    });
  
    const { status, results } = await response.json();
  
    let locality = "";
    let postalCode = "";
    let city = "";
    let state = "";
    let country = "";
    if (status === "OK") {
      const firstAddress = results[0];
      try {
        if (typeof firstAddress.address_components !== "undefined")
          for (let i = 0; i < firstAddress.address_components.length; i += 1) {
            for (
              let b = 0;
              b < firstAddress.address_components[i].types.length;
              b += 1
            ) {
              if (firstAddress.address_components[i].types[b] === "locality") {
                city = firstAddress.address_components[i].long_name;
              }
              if (firstAddress.address_components[i].types[b] === "postal_code") {
                postalCode = firstAddress.address_components[i].long_name;
              }
              if (firstAddress.address_components[i].types[b] === "country") {
                country = firstAddress.address_components[i].long_name;
              }
              if (
                firstAddress.address_components[i].types[b] ===
                "administrative_area_level_1"
              ) {
                state = firstAddress.address_components[i].long_name;
              }
              if (
                firstAddress.address_components[i].types[b] ===
                "sublocality_level_1"
              ) {
                locality = firstAddress.address_components[i].long_name;
              }
            }
          }
      } catch (e) {
        city = "";
        locality = "";
        postalCode = "";
        state = "";
        country = "";
      }
  
      let address = "";
      try {
        address =
          typeof firstAddress.formatted_address !== "undefined"
            ? firstAddress.formatted_address
            : "";
      } catch (e) {
        address = "";
      }
  
      return {
        city,
        postalCode,
        locality,
        address,
        state,
        country,
        mainText: address?.split(",")?.[0] || "",
        secondaryText: address,
      };
    }
    return {
      city: "",
      locality: "",
      postalCode: "",
      address: "",
      state: "",
      country: "",
      mainText: "",
      secondaryText: "",
      error: true,
    };
  };
  
  export const getAddressFromPincode = async (
    pincode: string
  ): Promise<ReverseGeoCode> => {
    const basePath =
      process.env.NEXT_PUBLIC_ENV === "LOCAL"
        ? ""
        : process.env.NEXT_PUBLIC_GOOGLE_MAPS_URL;
    const URL = `/maps/api/geocode/json?address=${pincode}&key=${process.env.NEXT_PUBLIC_GMAPS_API_KEY}`;
  
    const response = await fetch(basePath + URL, {
      headers: {},
    });
  
    const { status, results } = await response.json();
  
    let locality = "";
    let postalCode = "";
    let city = "";
    let state = "";
    let country = "";
    if (status === "OK") {
      const firstAddress = results[0];
      try {
        if (typeof firstAddress.address_components !== "undefined")
          for (let i = 0; i < firstAddress.address_components.length; i += 1) {
            for (
              let b = 0;
              b < firstAddress.address_components[i].types.length;
              b += 1
            ) {
              if (firstAddress.address_components[i].types[b] === "locality") {
                city = firstAddress.address_components[i].long_name;
              }
              if (firstAddress.address_components[i].types[b] === "postal_code") {
                postalCode = firstAddress.address_components[i].long_name;
              }
              if (firstAddress.address_components[i].types[b] === "country") {
                country = firstAddress.address_components[i].long_name;
              }
              if (
                firstAddress.address_components[i].types[b] ===
                "administrative_area_level_1"
              ) {
                state = firstAddress.address_components[i].long_name;
              }
              if (
                firstAddress.address_components[i].types[b] ===
                "sublocality_level_1"
              ) {
                locality = firstAddress.address_components[i].long_name;
              }
            }
          }
      } catch (e) {
        city = "";
        locality = "";
        postalCode = "";
        state = "";
        country = "";
      }
  
      let address = "";
      try {
        address =
          typeof firstAddress.formatted_address !== "undefined"
            ? firstAddress.formatted_address
            : "";
      } catch (e) {
        address = "";
      }
  
      return {
        city,
        postalCode,
        locality,
        address,
        state,
        country,
        mainText: address?.split(",")?.[0] || "",
        secondaryText: address,
      };
    }
    return {
      city: "",
      locality: "",
      postalCode: "",
      address: "",
      state: "",
      country: "",
      mainText: "",
      secondaryText: "",
      error: true,
    };
  };
  